import imgOrder from '../img/Products/AI/ai-erp-order.jpg';
import imgProcurement from '../img/Products/AI/ai-erp-procurement.jpg';
import imgInventory from '../img/Products/AI/ai-erp-inventory.jpg';
import imgDialog from '../img/Products/AI/ai-erp-dialog.jpg';

export const inventoryErpIntro = {
    title: '智慧進銷存管理系統',
    titleEn: 'AI-Driven ERP & Inventory System',
    subtitle:
        '智慧進銷存管理系統將訂單、採購、庫存三大核心模組與 AI 自然語言深度整合——免翻找報表，用對話就能查詢進銷存與全廠數據。',
    overview:
        '這不只是傳統的進銷存，更是企業的數據智慧大腦。系統完美整合「訂單、採購、庫存」三大核心範疇，並引入先進的 AI 語意對話核心。從此，管理階層與現場人員無需再層層點選複雜的報表表單，只要如同與特助聊天一般輸入自然語言，AI 就會即時穿透資料庫，為您提取、分析並生成決策建議。',
    highlights: [
        { label: '智慧訂單', id: 'module-order' },
        { label: '精準採購', id: 'module-procurement' },
        { label: '智能庫存', id: 'module-inventory' },
        { label: 'AI 對話查詢', id: 'ai-dialog' },
    ],
};

export const inventoryModules = [
    {
        id: 'module-order',
        tag: '訂單管理',
        title: '智慧訂單管理模組',
        titleEn: 'Sales & Order Management',
        image: imgOrder,
        imageAlt: '訂單出貨與物流管理',
        imageFit: 'cover',
        overview: '從前端詢價到後端履約的一條龍自動化管理。',
        advantages: [
            {
                label: '全方位客戶與報價優化',
                text: '完善的「客戶資料管理」與「報價單資料管理」，歷史出價紀錄一目了然。',
            },
            {
                label: '高效訂單與出貨履約',
                text: '透過「訂單資料管理」與「訂單出貨管理」，精準鎖定每一筆銷貨進度。',
            },
            {
                label: '完善售後',
                text: '內建「出貨退回管理」，確保客訴與退換貨流程透明、帳目清晰。',
            },
        ],
    },
    {
        id: 'module-procurement',
        tag: '採購管理',
        title: '精準採購管理模組',
        titleEn: 'Procurement & Supplier Management',
        image: imgProcurement,
        imageAlt: '採購與供應鏈管理',
        imageFit: 'cover',
        overview: '控管企業供應鏈的黃金動脈，降低資金積壓風險。',
        advantages: [
            {
                label: '供應鏈動態掌控',
                text: '建立精細的「供應商資料管理」，評估交期與供貨穩定度。',
            },
            {
                label: '彈性請採購流程',
                text: '支援內部「請購單管理」流暢轉為對外的「採購單管理」，權責分明。',
            },
            {
                label: '進貨與逆向物流',
                text: '提供「採購進貨管理」與「進貨退回管理」，嚴格把關入庫品質與退廠追蹤。',
            },
        ],
    },
    {
        id: 'module-inventory',
        tag: '庫存管理',
        title: '智能庫存管理模組',
        titleEn: 'Inventory & Warehouse Intelligence',
        image: imgInventory,
        imageAlt: '倉儲與庫存管理',
        imageFit: 'cover',
        overview: '物料流轉的核心中樞，實現零時差的倉儲調度。',
        advantages: [
            {
                label: '結構化料件基底',
                text: '透過「料號基本資料管理」與「材料清單資料管理 (BOM)」，精準掌握產品的 DNA。',
            },
            {
                label: '嚴謹的現場領退料',
                text: '「領料資料管理」與「領料退回資料管理」緊密連動產線需求，杜絕物料浪費。',
            },
            {
                label: '多倉調度與設定',
                text: '提供「倉庫資料設定管理」與「料件調撥管理」，輕鬆應對多倉儲、跨廠區的即時橫向調度。',
            },
        ],
    },
];

export const aiDialogFeature = {
    id: 'ai-dialog',
    tag: '核心亮點',
    title: 'AI 數據即時對話查詢系統',
    titleEn: 'AI Conversational Data Intelligence',
    image: imgDialog,
    imageAlt: 'AI 數據分析與對話查詢',
    imageFit: 'cover',
    overview:
        '系統最強大的創新在於「AI 數據對話框」。不論是內勤客服、採購人員還是高階主管，都能透過自然語言（中文／英文）與系統直接對答，AI 會自動解析語意，直接調取資料庫並將結果「圖表化」或「表格化」呈現。',
    scenarios: [
        {
            label: '場景 A｜客服／業務催貨',
            userInput: '幫我查客戶匯融科技上週訂的紙箱出貨了沒？預計什麼時候到？',
            aiReply:
                '已為您查詢［訂單出貨管理］。該筆訂單（單號：SO-20260604）已於今日上午 09:30 由自有車隊出貨，預計下午 14:00 送達客戶端。',
        },
        {
            label: '場景 B｜採購／主管庫存預警',
            userInput: '有哪些電子零件或包材目前低於安全庫存？最近一次是跟哪家供應商採購的？',
            aiReply:
                '目前［庫存管理］中有 3 項料件低於安全水位。其中瓦楞紙箱（料號：BX-001）僅剩 50 個，最近一次是向「全球包裝股份有限公司」採購，當時採購單價為…',
        },
        {
            label: '場景 C｜跨模組動態分析',
            userInput: '上個月請購單裡，有哪些材料還沒轉成採購單？金額總共多少？',
            aiReply:
                '已跨模組為您交叉比對。［請購單管理］中目前有 5 筆未轉採購，主要集中在 A 材料，預估總金額為…',
        },
    ],
};

export default inventoryModules;
